import { render, staticRenderFns } from "./SolicitudesCaja.vue?vue&type=template&id=7b19723d&"
import script from "./SolicitudesCaja.vue?vue&type=script&lang=js&"
export * from "./SolicitudesCaja.vue?vue&type=script&lang=js&"
import style0 from "./SolicitudesCaja.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports